var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1932 4.12666L18.5532 6.44666C17.2599 7.08666 15.7532 7.08666 14.4599 6.44666L9.80655 4.11333C5.83322 2.12666 1.63322 6.42 3.71322 10.3533L4.80655 12.4067C4.95322 12.6867 5.19322 12.9133 5.48655 13.0467L22.3532 20.6333C23.0465 20.94 23.8599 20.66 24.2066 19.9933L29.2866 10.34C31.3532 6.42 27.1666 2.12666 23.1932 4.12666Z",
    fill: "#1775E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.3001 22.2467L10.2601 17.2733C9.02011 16.7133 7.76677 18.0467 8.40677 19.2467L12.4601 26.94C14.1801 30.2067 18.8468 30.2067 20.5668 26.94L21.9934 24.22C22.3668 23.4867 22.0468 22.5933 21.3001 22.2467Z",
    fill: "#1775E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectDown);
export default __webpack_public_path__ + "static/media/direct-down.7bd26a067145b8651ae43a8727f5c75e.svg";
export { ForwardRef as ReactComponent };